import { render } from "./RuleDetail.vue?vue&type=template&id=0d56108a"
import script from "./RuleDetail.vue?vue&type=script&lang=js"
export * from "./RuleDetail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__